module.exports = __webpack_public_path__ + "images/3x4-billboard-717b1d3f0e86467875ee03ffd1fd95f0.jpg";